import React from 'react';
import { Route, Switch } from 'react-router-dom';
import RedirectToHome from '../../components/RedirectToHome';
import SchedulerShiftsHeader from './SchedulerShiftsHeader';
import { routes } from './SchedulerShiftsHeader/routes';

const Content: React.FC = () => (
  <Switch>
    {Object.values(routes()).map(({ render, route }, i) => (
      <Route
        key={i}
        exact={true}
        path={route.template()}
        render={() => render()}
      />
    ))}
    <Route path="*">
      <RedirectToHome />
    </Route>
  </Switch>
);

const SchedulerShifts: React.FC = () => {
  return (
    <>
      <SchedulerShiftsHeader />
      <Content />
    </>
  );
};

export default SchedulerShifts;
